import Comment from '../Comment';
import BaseEventPayload from './BaseEventPayload';

export default class CommentEventPayload extends BaseEventPayload {
  constructor(data = {}, parentEventLog) {
    super(CommentEventPayload, data, parentEventLog);
    this.commentText = data.commentText;
    this.previousCommentText = data.previousCommentText;
    this.comment = data.comment && new Comment(data.comment);
  }
}
